import { render, staticRenderFns } from "./staffStats.vue?vue&type=template&id=5013f398&scoped=true"
import script from "./staffStats.vue?vue&type=script&lang=js"
export * from "./staffStats.vue?vue&type=script&lang=js"
import style0 from "./staffStats.vue?vue&type=style&index=0&id=5013f398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013f398",
  null
  
)

export default component.exports